import { RESET_ALL_STATES } from "../actions/actions";
import { persistor } from "../store";

const authMiddleware = store => next => action => {    
    return next(action);
  };
  
  const isTokenExpired = (token) => {
    const payload = JSON.parse(atob(token?.split('.')[1]));
    const expirationTime = payload.exp * 1000;
    return Date.now() >= expirationTime;
  };
  
  export default authMiddleware;
